import React from 'react'

function Key_Feature() {
  return (
   <>
     <section className="overflow-hidden space" id="target-section">
  <div className="container">
    <div className="title-area text-center">
      <span className="sub-title"><i className="fal fa-book me-2" /> What We Do</span>
      <h2 className="sec-title">Online Education Tailored to You</h2>
    </div>
    <div className="row gy-4 justify-content-center">
      <div className="col-md-6 col-lg-4">
        <div className="service-card style3">
          <div className="service-card-content">
            <div className="service-card-icon">
              <img src="assets/img/icon/service-icon-3-1.svg" alt="Icon" />
            </div>
            <h3 className="box-title">Learn From Anywhere</h3>
            <p className="service-card-text"> Competently unleash competitive initiatives for alternative interfaces. Enthusiastically supply resource eveling platforms</p>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="service-card style3">
          <div className="service-card-content">
            <div className="service-card-icon">
              <img src="assets/img/icon/service-icon-3-2.svg" alt="Icon" />
            </div>
            <h3 className="box-title">Expert Instructor</h3>
            <p className="service-card-text"> Competently unleash competitive initiatives for alternative interfaces. Enthusiastically supply resource eveling platforms</p>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-4">
        <div className="service-card style3">
          <div className="service-card-content">
            <div className="service-card-icon">
              <img src="assets/img/icon/service-icon-3-3.svg" alt="Icon" />
            </div>
            <h3 className="box-title">24/7 Live Support</h3>
            <p className="service-card-text"> Competently unleash competitive initiatives for alternative interfaces. Enthusiastically supply resource eveling platforms</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
   
   </>
  )
}

export default Key_Feature